<template>
    <transition name="slide-fade">
        <div v-show="value" class="side-menu" :class="{
                    'side-menu-active': value
                }">

            <div class="menu-content-wrapper">
                <div class="side-menu-brand">
                    <a class="menu-brand-content" href="javascript:void(0)">
                        <img :src="companyLogoUrl" alt>
                    </a>
                </div>

                <ul class="side-menu-list">
                    <template v-for="(menuItem, index) in sideMenuList">
                        <template v-if="!menusToExcludeList.includes(menuItem.name)">
                            <li v-if="menuItem.parent" :key="index" class="menu-list-item" :class="{
                                'booking-button': menuItem.name === 'user-doctor-appointment-create',
                                'video-guide-button': menuItem.name === 'video-guide-doctor' || menuItem.name === 'video-guide-user'
                            }">
                                <div @click="menuItem.expand = !menuItem.expand" :class="{
                                'telehealth-button': menuItem.meta.title === 'Telehealth'}">
                                    <div class="list-item-content">
                                        <div class="menu-active-indicator"></div>
                                        <div class="menu-item-icon">
                                            <i :class="[
                                                'fas',
                                                menuItem.meta.icon
                                            ]"></i>
                                        </div>
                                        <div :class="['menu-item-title', { 'highlight': menuItem.meta.highlight }]">
                                            {{menuItem.meta ? menuItem.meta.title : ""}}

                                        </div>
                                        <div :class="['menu-item-action', 'fas', { 'fa-angle-up': menuItem.expand ? true : false }, { 'fa-angle-down': menuItem.expand ? false : true }]"></div>
                                    </div>
                                </div>
                                <template v-if="menuItem.expand">
                                    <li v-for="childItem in menuItem.childs" :key="childItem.name" class="menu-list-item child" :class="{
                                        'booking-button': childItem.name === 'user-doctor-appointment-create',
                                        'video-guide-button': childItem.name === 'video-guide-doctor' || childItem.name === 'video-guide-user'
                                    }">
                                        <template v-if="!menusToExcludeList.includes(childItem.name)">
                                            <router-link class="list-item-content" :to="{
                                                    name: childItem.name
                                                }">
                                                <div class="menu-active-indicator"></div>
                                                <div class="menu-item-icon">
                                                    <i :class="[
                                                        'fas',
                                                        childItem.meta.icon
                                                    ]"></i>
                                                </div>
                                                <div class="menu-item-title">
                                                    {{childItem.meta ? childItem.meta.title : ""}}
                                                </div>
                                                <div class="menu-item-action"></div>
                                            </router-link>
                                        </template>
                                    </li>
                                </template>
                            </li>
                            <li v-else :key="index" class="menu-list-item" :class="{
                                'booking-button': menuItem.name === 'user-doctor-appointment-create',
                                'video-guide-button': menuItem.name === 'video-guide-doctor' || menuItem.name === 'video-guide-user'
                            }">
                                <router-link class="list-item-content" :to="{
                                        name: menuItem.name
                                    }">
                                    <div class="menu-active-indicator"></div>
                                    <div class="menu-item-icon">
                                        <i :class="[
                                            'fas',
                                            (menuItem.meta && menuItem.meta.icon) ? menuItem.meta.icon : ''
                                        ]"></i>
                                    </div>
                                    <div class="menu-item-title">
                                        {{menuItem.meta ? menuItem.meta.title : ""}}
                                    </div>
                                    <div class="menu-item-action"></div>
                                </router-link>
                            </li>
                        </template>
                    </template>
                </ul>
            </div>
        </div>
    </transition>
</template>

<script>
import { isCompanySponsoredType } from '@/config/companyTypes';
export default {
    'name': 'SideMenu',
    'props': {

        'value': {

            'type': Boolean,

            'default': true

        }

    },

    'computed': {
        companyLogoUrl () {
            return this.$store.state.operator.companyLogoUrl;
        },

        sideMenuList () {
            return this.$store.state.app.sideMenuList;
        },

        isPublic () {
            return this.$store.state.isPublic;
        },

        isAdmin () {
            return this.$store.state.user.userRole === 1;
        },

        isCompany () {
            return this.$store.state.user.userRole === 2;
        },

        isUser () {
            return this.$store.state.user.userRole === 3;
        },

        isDoctor () {
            return this.$store.state.user.userRole === 4;
        },
        menusToExcludeList () {
            if (this.$store.state.user.userRole === 4) {
                if (!isCompanySponsoredType(this.$store.state.user.companyType)) {
                    return [
                        'dashboard-company',
                        'company-manage-credit',
                        'employee-credit-usage',
                        'employee-spending-report',
                        'Outpatient Benefit Limit Setting',
                        'video-guide-corporate-sponsored-create-and-set-benefits',
                        'video-guide-corporate-sponsored-add-new-employee',
                        'company-invoices'
                    ];
                } else {
                    return [
                        'employee-self-paying-list',
                        'video-guide-self-paying-add-new-employee',
                        'video-guide-self-paying-deactivate-employee'
                    ];
                }
            }

            if (this.$store.state.user.userRole === 1) {
                if (!(isCompanySponsoredType(this.$store.state.user.companyType) || isCompanySponsoredType(this.$store.state.user.spouseOrDependentCompanyType))) {
                    return [
                        'company-credit-balance'
                    ];
                }
            }

            return [];
        }
    },

    'watch': {

        $route (to, from) {
            this.$nextTick(() => {
                this.checkCollapseExpand();
            });
        }

    },
    'methods': {

        menuGroupClicked (event) {
            let parentClass = 'list-item-collapse-header';

            let clickedDom = event.target;

            while (

                (clickedDom = clickedDom.parentElement) &&

                    !clickedDom.classList.contains(parentClass)

            );

            if (clickedDom) {
                if (clickedDom.classList.contains('expand')) {
                    clickedDom.classList.remove('expand');
                } else {
                    clickedDom.classList.add('expand');
                }
            }
        },

        checkCollapseExpand () {
            let highlightedDom = document.querySelector('.router-link-active');

            if (highlightedDom) {
                let isGroupItem = highlightedDom.classList.contains(

                    'list-item-group-item'

                );

                if (isGroupItem) {
                    let parentWrapper = highlightedDom;

                    let parentWrapperClass = 'list-item-group';

                    while (

                        (parentWrapper = parentWrapper.parentElement) &&

                            !parentWrapper.classList.contains(parentWrapperClass)

                    );

                    if (parentWrapper) {
                        let expandHeader = parentWrapper.querySelector(

                            '.list-item-collapse-header'

                        );

                        if (expandHeader) {
                            expandHeader.classList.add('expand');
                        }
                    }
                }
            }
        },

        logoutUser () {
            this.$store.commit('setAppStatus', true);
            this.axios.get('account/logout').finally(() => {
                this.$store.commit('setAppStatus', true);

                this.$store.commit('clearUserState');

                this.$router.push({
                    'name': 'login'
                });
            });
        }

    }

};

</script>

<style>
    :root {
        --menu-item-height: 48px;
    }

    .side-menu {
        position: fixed;
        width: 250px;
        min-height: 100vh;
        height: 100vh;
        padding-bottom: 48px;
        background-color: #2f323a;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }

    .side-menu .side-menu-brand {
        height: 100px;
        color: #fff;
        font-size: 1.5rem;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;

    }

    .side-menu .side-menu-brand .menu-brand-content img {
        display: block;
        max-height: 40px;
        width: auto;
    }

    .side-menu-list {
        list-style: none;
        list-style-type: none;
        padding: 0;
        margin: 0;
    }

    .side-menu-list .menu-list-item {
        color: #4c4f58;
        list-style: none;
        background-color: #2f323a;
    }

    .side-menu-list .menu-list-item.booking-button :not(.router-link-exact-active) .menu-item-title {
        font-weight: bold;
        color: #009344;
        animation: glow 2s ease-in-out infinite alternate;
    }

    .side-menu-list .menu-list-item.booking-button :not(.router-link-exact-active) .menu-item-icon {
        color: #009344;
    }

    .side-menu-list .menu-list-item div.telehealth-button :not(.router-link-exact-active) .menu-item-title {
        font-weight: bold;
        color: #009344;
        animation: glow 2s ease-in-out infinite alternate;
    }

    .side-menu-list .menu-list-item div.telehealth-button :not(.router-link-exact-active) .menu-item-icon {
        color: #009344;
    }
    .side-menu-list .menu-list-item.video-guide-button :not(.router-link-exact-active) .menu-item-title {
        font-weight: bold;
        color: #007bff;
        animation: glow 2s ease-in-out infinite alternate;
    }

    .side-menu-list .menu-list-item.video-guide-button :not(.router-link-exact-active) .menu-item-icon {
        color: #007bff;
    }

    .side-menu-list .menu-list-item .list-item-content {
        display: flex;
        align-items: center;
        height: 48px;
        padding-right: 5px;
        color: #9499a8;
        transition: 0.2s background-color ease-in-out;
    }

    .side-menu-list .menu-list-item.child{
        background: #474747;
    }

    .side-menu-list .menu-list-item .list-item-content:hover {
        background-color: #25282e;
        text-decoration: none;
    }

    .side-menu-list .menu-list-item .list-item-content .menu-active-indicator {
        width: 5px;
        height: 48px;
        background-color: transparent;
        transition: 0.2s background-color ease-in-out;
    }

    .side-menu-list .menu-list-item .list-item-content .menu-item-icon {
        width: 36px;
        text-align: center;
        margin-right: 5px;
    }

    .side-menu-list .menu-list-item .list-item-content .menu-item-title {
        flex: 1;
        font-size: 14px;
    }

    .side-menu-list .menu-list-item .list-item-content .menu-item-title.highlight {
        color: greenyellow;
        font-weight: bold;
    }

    .side-menu-list .menu-list-item .list-item-content .menu-item-action {
        width: 30px;
        text-align: right;
        padding-right: 5px;
    }

    /*Router Link Active Styles*/

    .side-menu-list .menu-list-item .list-item-content.router-link-exact-active {
        background-color: #25282e;
    }

    .side-menu-list .menu-list-item.child .list-item-content.router-link-exact-active {
        background: #383838;
    }

    .side-menu-list .menu-list-item .list-item-content.router-link-exact-active .menu-active-indicator {
        background-color: #009344;
    }

    .side-menu-list .menu-list-item .list-item-content.router-link-exact-active .menu-item-title {
        color: #fff;
    }

    /*Router Link Active Styles*/

    /*Collapsible*/

    .side-menu-list .list-item-collapse-header {
        cursor: pointer;
        transition: 0.3s background-color ease-in-out;
    }

    .side-menu-list .list-item-collapse-header.expand {
        background-color: #25282e;
    }

    .side-menu-list .list-item-collapse-header .menu-item-action .fa {
        transition: 0.2s ease-out;
    }

    .side-menu-list .list-item-collapse-header.expand .menu-item-action .fa {
        transform: rotate(180deg);
    }

    .side-menu-list .list-item-collapsible {
        height: 0px;
        overflow: hidden;
        transition: 0.3s ease-in-out;
        background-color: #25282e;
    }

    .side-menu-list .list-item-collapse-header.expand+.list-item-collapsible {
        height: auto;
    }

    .side-menu-list .menu-list-item .list-item-collapsible .router-link-active .menu-active-indicator {
        background-color: inherit;
    }

    .side-menu-list .menu-list-item .list-item-collapsible .router-link-active.router-link-exact-active .menu-active-indicator {
        background-color: #009344;
    }

    .side-menu-list .list-item-collapsible .menu-list-item .list-item-content.router-link-active {
        background-color: inherit;
    }

    .side-menu-list .list-item-collapsible .menu-list-item .list-item-content.router-link-active.router-link-exact-active {
        background-color: #25282e;
    }

    .side-menu-list .menu-list-item .list-item-content.router-link-active .menu-item-title {
        color: inherit;
    }

    .side-menu-list .menu-list-item .list-item-content.router-link-active.router-link-exact-active .menu-item-title {
        color: #fff;
    }

    /*Collapsible*/

    /*Transition*/

    .slide-fade-enter-active,
    .slide-fade-leave-active {
        transition: all 0.2s ease-in-out;

    }

    .slide-fade-enter,
    .slide-fade-leave-to {
        transform: translateX(-250px);
        opacity: 0;
    }

    /*Transition*/

</style>
